/* Mobile board: one column of blocks 26 px apart, inside a 20 px gutter. */
.footer {
  /* A flex item of the page column: with overflow hidden it would otherwise shrink to nothing. */
  flex: none;
  position: relative;
  isolation: isolate;
  overflow: hidden;
  background: var(--footer-base);
  padding: 44px var(--gutter) 32px;
}

.photo {
  position: absolute;
  inset: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: var(--footer-photo-position, 78% center);
}

/* --footer-veil: a site's wash over the photo (painted after it, still behind
   the text); none set, the photo shows as it is. */
.footer::after {
  content: '';
  position: absolute;
  inset: 0;
  z-index: -1;
  background: var(--footer-veil, none);
  pointer-events: none;
}

.columns {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 26px 20px;
}

.brand,
.language {
  grid-column: 1 / -1;
}

.brand {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.home {
  align-self: flex-start;
  display: flex;
}

.about,
.languageHeading,
.long,
.column > .link:nth-of-type(4) {
  display: none;
}

.about {
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
  color: var(--text-secondary);
}

.column {
  display: flex;
  flex-direction: column;
}

.heading {
  margin: 0 0 6px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--label);
}

.link {
  padding: 8px 0;
  font-size: 14px;
}

.languages {
  display: flex;
  gap: 18px;
  font-size: 14px;
}

.currentLanguage {
  font-weight: 600;
}

.legal {
  margin: 26px 0 0;
  padding-top: 18px;
  border-top: 1px solid var(--footer-rule);
  font-size: 12px;
  line-height: 1.6;
  color: var(--text-muted);
}

.sister {
  display: block;
  margin-top: 6px;
}

.sister a {
  text-decoration: underline;
}

/* Main board: four columns right of the palm leaf. */
@media (min-width: 1024px) {
  .footer {
    padding: 0;
  }

  .photo {
    object-position: left center;
  }

  .columns {
    max-width: var(--container);
    margin: 0 auto;
    padding: 64px var(--gutter) 28px var(--footer-inset);
    grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
    gap: 36px;
    box-sizing: border-box;
  }

  .brand,
  .language {
    grid-column: auto;
  }

  /* The lockup is far taller than a column heading: top-aligned, the brand
     block ran ~20 px below the link lists and read as sitting low. Raised to
     centre it on them. */
  .brand {
    margin-top: -12px;
  }

  .about,
  .languageHeading {
    display: block;
  }

  .long {
    display: inline;
  }

  .column > .link:nth-of-type(4) {
    display: block;
  }

  .short {
    display: none;
  }

  .heading {
    margin-bottom: 10px;
    font-size: 11px;
    letter-spacing: 0.24em;
  }

  .link {
    padding: 7px 0;
  }

  .languages {
    padding: 7px 0;
  }

  .legal {
    max-width: var(--container);
    margin: 0 auto;
    padding: 20px var(--gutter) 36px var(--footer-inset);
    box-sizing: border-box;
  }
}
